const SELECT_PATHOLOGY = 'currentSelection//SELECT_PATHOLOGY'
const SELECT_IMMUNIZATION = 'currentSelection//SELECT_IMMUNIZATION'
const SELECT_RECOMMENDATION = 'currentSelection//SELECT_RECOMMENDATION'
const SELECT_EMPTY_INSERTION = 'currentSelection//SELECT_EMPTY_INSERTION'
const SELECT_PREVIOUS_INSERTION = 'currentSelection//SELECT_PREVIOUS_INSERTION'

const REMOVE_SELECTED_PATHOLOGY = 'currentSelection//REMOVE_SELECTED_PATHOLOGY'
const REMOVE_SELECTED_IMMUNIZATION = 'currentSelection//REMOVE_SELECTED_IMMUNIZATION'
const REMOVE_SELECTED_RECOMMENDATION = 'currentSelection//REMOVE_SELECTED_RECOMMENDATION'
const REMOVE_EMPTY_INSERTION = 'currentSelection//REMOVE_EMPTY_INSERTION'
const REMOVE_PREVIOUS_INSERTION = 'currentSelection//REMOVE_PREVIOUS_INSERTION'

const REMOVE_CURRENT_SELECTIONS = 'currentSelection//REMOVE_CURRENT_SELECTIONS'

export {
  SELECT_PATHOLOGY,
  SELECT_IMMUNIZATION,
  SELECT_RECOMMENDATION,
  SELECT_EMPTY_INSERTION,
  REMOVE_SELECTED_PATHOLOGY,
  REMOVE_SELECTED_IMMUNIZATION,
  REMOVE_SELECTED_RECOMMENDATION,
  REMOVE_EMPTY_INSERTION,
  REMOVE_CURRENT_SELECTIONS,
  SELECT_PREVIOUS_INSERTION,
  REMOVE_PREVIOUS_INSERTION
}
